import React from "react";
import { useNavigate } from "react-router-dom";
import useCart from "../hooks/useCart";
import useAuth from "../hooks/useAuth";
import "./CartPage.css";
import TermsAndConditions from "./TermsAndConditions.jsx";

const CartPage = () => {
  const { cart, removeFromCart, updateQuantity, getTotalPrice, clearCart } = useCart();
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [showTermsModal, setShowTermsModal] = React.useState(false);
  const [termsAccepted, setTermsAccepted] = React.useState(false);

  // Redirect to login if not authenticated
  React.useEffect(() => {
    if (!loading && !user) {
      navigate("/login");
    }
  }, [user, loading, navigate]);

  const handleQuantityChange = (productId, newQuantity) => {
    updateQuantity(productId, parseInt(newQuantity));
  };

  const handleRemoveItem = (productId) => {
    removeFromCart(productId);
  };

  const handleCheckout = () => {
    setShowTermsModal(true);
  };
  const handleAcceptTerms = () => {
    setShowTermsModal(false);
    setTermsAccepted(true);
    navigate('/checkout');
  };

  const handleContinueShopping = () => {
    navigate("/store");
  };

  if (loading) {
    return <div className="cart-loading">Loading...</div>;
  }

  if (!user) {
    return null; // Will redirect in useEffect
  }

  return (
    <div className="cart-page-container">
      {showTermsModal && (
        <div style={{position:'fixed',top:0,left:0,width:'100vw',height:'100vh',background:'rgba(0,0,0,0.5)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center'}}>
          <div style={{background:'#fff',borderRadius:8,boxShadow:'0 2px 16px rgba(0,0,0,0.2)',maxWidth:600,width:'90vw',maxHeight:'90vh',overflow:'auto',position:'relative'}}>
            <TermsAndConditions onDone={handleAcceptTerms} />
            <button onClick={()=>setShowTermsModal(false)} style={{position:'absolute',top:10,right:16,fontSize:24,background:'none',border:'none',cursor:'pointer'}}>&times;</button>
          </div>
        </div>
      )}
      <h1>Your Shopping Cart</h1>

      {cart.length === 0 ? (
        <div className="empty-cart">
          <p>Your cart is empty</p>
          <button onClick={handleContinueShopping} className="continue-shopping">
            Continue Shopping
          </button>
        </div>
      ) : (
        <div className="cart-content">
          <div className="cart-items">
            <div className="cart-header">
              <span className="header-product">Product</span>
              <span className="header-price">Price</span>
              <span className="header-quantity">Quantity</span>
              <span className="header-total">Total</span>
              <span className="header-action">Action</span>
            </div>

            {cart.map((item) => (
              <div key={item.product._id} className="cart-item">
                <div className="item-product">
                  <img src={item.product.images[0]} alt={item.product.title} />
                  <div className="item-details">
                    <h3>{item.product.title}</h3>
                    <p>{item.product.material}</p>
                  </div>
                </div>

                <div className="item-price">₹{item.product.offerPrice}</div>

                <div className="item-quantity">
                  <button
                    onClick={() => handleQuantityChange(item.product._id, item.quantity - 1)}
                    className="quantity-btn"
                    disabled={item.quantity <= 1}
                  >
                    -
                  </button>
                  <input
                    type="number"
                    min="1"
                    value={item.quantity}
                    onChange={(e) =>
                      handleQuantityChange(item.product._id, e.target.value)
                    }
                  />
                  <button
                    onClick={() => handleQuantityChange(item.product._id, item.quantity + 1)}
                    className="quantity-btn"
                  >
                    +
                  </button>
                </div>

                <div className="item-total">
                  ₹{(item.product.offerPrice * item.quantity).toFixed(2)}
                </div>

                <div className="item-action">
                  <button
                    onClick={() => handleRemoveItem(item.product._id)}
                    className="remove-btn"
                  >
                    Remove
                  </button>
                </div>
              </div>
            ))}
          </div>

          <div className="cart-summary">
            <h2>Order Summary</h2>
            <div className="summary-row">
              <span>Subtotal</span>
              <span>₹{getTotalPrice().toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Shipping</span>
              <span>{getTotalPrice() > 500 ? "Free" : "₹50"}</span>
            </div>
            <div className="summary-row total">
              <span>Total</span>
              <span>
                ₹{(getTotalPrice() + (getTotalPrice() > 500 ? 0 : 50)).toFixed(2)}
              </span>
            </div>

            <div className="coupon-code">
              <input type="text" placeholder="Enter coupon code" />
              <button>Apply</button>
            </div>

            <button onClick={handleCheckout} className="checkout-btn">
              Proceed to Checkout
            </button>

            <div className="cart-actions">
              <button onClick={handleContinueShopping} className="continue-shopping">
                Continue Shopping
              </button>
              <button onClick={clearCart} className="clear-cart">
                Clear Cart
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CartPage;